/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreatePaymentPlan/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconCompleteContract from 'DesignSystem/Svgs/TysiaIconCompleteContract/index'



/** @type {import('Simple/types.js').View} */
export default function CreatePaymentPlan({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/TreatmentPlanStatus/Content/Content/Icon/CreatePaymentPlan"
  
}) {
let dtColorsBlue500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.500'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaIconCompleteContract
  viewPath={`${viewPath}/TysiaIconCompleteContract`}
 fill={dtColorsBlue500}
 marginLeft={dtSpaceXs}
 marginRight={dtSpaceXs}
 width={18}
 height={18}
/>
{children}
</React.Fragment>)
}